<!-- A list tile to pick a TVSpotEntry to link with for playlist ordering. -->

<template>
  <v-hover v-if="entry && entry.spot">
    <v-list-tile
      slot-scope="{hover}"
      :title="tooltip"
      :disabled="disabled"
      class="list-tile-auto-height"
      :class="{
        error: hover && currentlyLinked,
      }"
      @click="emitSelected()"
    >
      <v-list-tile-action
        class="mr-2 my-1"
        style="min-width: 96px; min-height: 54px"
      >
        <v-img
          :src="thumbnailURL"
          contain
          :max-width="96"
          :max-height="54"
        />
      </v-list-tile-action>
      <v-list-tile-title>
        <strong
          :class="{
            'msr--text': currentlyLinked && !hover,
            'white--text': currentlyLinked && hover,
          }"
        >{{ entry.spot.title }}</strong>
      </v-list-tile-title>
      <v-list-tile-action class="justify-center">
        <v-slide-x-reverse-transition>
          <v-icon
            v-if="hover && !currentlyLinked"
            medium
            class="msr--text"
          >
            link
          </v-icon>
        </v-slide-x-reverse-transition>
        <v-btn
          v-if="currentlyLinked"
          color="error"
          class="ma-0"
          icon
          dark
          small
        >
          <v-icon> clear </v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-hover>
</template>

<script>
export default {
  name: 'LinkSpotEntryTile',
  props: {
    entry: {
      type: Object,
      required: true,
    },
    currentlyLinked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    spot() {
      return this.entry.spot;
    },
    thumbnailURL() {
      return this.spot.thumbnail_url;
    },
    tooltip() {
      return this.currentlyLinked
        ? this.$t('unlinkContentFromThis')
        : this.$t('linkContentsToThis');
    },
  },
  methods: {
    emitSelected() {
      this.currentlyLinked
        ? this.$emit('deselected', this.entry)
        : this.$emit('selected', this.entry);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LinkSpotEntryTile.vue